import { useEffect, useState } from "react";
import { Modal, Steps, Form, Input, Button, Select, Row, Col, message, Radio, Spin } from "antd";
import { uri } from "../backendUri";
import axiosApi from "../axiosApi/axiosApi";

const { Step } = Steps;

const AddNewOrderToWooCommerce = ({ isOpen, onClose, fetchOrders }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [variations, setVariations] = useState({})
    const [selectedAttributes, setSelectedAttributes] = useState({});
    const [matchedVariation, setMatchedVariation] = useState({});
    const [productLoading, setProductLoading] = useState(true)
    const [products, setProducts] = useState([])
    const steps = [
        { title: "Select Products", key: "selectProducts" },
        { title: "Billing", key: "billing" },
        { title: "Shipping", key: "shipping" },
        { title: "Select Status", key: "status" }
    ];
    const fetchProducts = async (page = 1, searchBy) => {

        setProductLoading(true);
        try {
            let { data } = await axiosApi.get(`/fetchWommerce-products-for-orders`);
            setProducts(data.products);
            message.success("Products fetched successfully!");

        } catch (error) {
            message.error("Failed to fetch Reports.");
        } finally {
            setProductLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts()
    }, [])

    const handleSaveOrder = async () => {
        try {
            const values = await form.getFieldsValue(true);
            setLoading(true);


            const lineItems = values.products.map(product => ({
                product_id: product.product_id,
                quantity: product.quantity,
                variation_id: matchedVariation[product?.product_id]?.id,
                meta_data: product.meta_data ? product.meta_data.map(attr => ({
                    key: attr?.key,
                    value: attr?.value,
                    display_key: attr?.display_key,
                    display_value: attr?.value,
                })) : []
            }));

            const data = {
                payment_method: "bacs",
                payment_method_title: "Bank Wire Transfer",
                billing: values.billing,
                shipping: values.shipping,
                line_items: lineItems,
                status: "processing",
                // meta_data: values.meta_data
            };

            let res = await axiosApi.post(`/create-wooCommerce-order`, data);
            if (res?.data) {
                fetchOrders();
                message.success("Order created successfully!");
            }
            onClose(false);
        } catch (error) {
            console.error("Error creating order:", error);
            message.error("Failed to create order. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    async function fetchProductVariations(productId) {
        if (variations[productId]?.length) {
            return;
        }
        try {
            if (!productId) {
                console.error("❌ Product ID is required");
                return null;
            }


            const { data } = await axiosApi.get(`/fetch-product-variations`, {
                params: { productId }
            });

            setVariations({ ...variations, [productId]: data })
            return data;
        } catch (error) {
            console.error("❌ Error fetching product variations:", error.response?.data || error.message);
            return null;
        }
    }


    const handleSelectAttribute = (attributeSlug, value, selectedProductId) => {
        const updatedAttributes = { ...selectedAttributes, [attributeSlug]: value };
        setSelectedAttributes(updatedAttributes);

        const matched = variations[selectedProductId]?.find((variation) =>
            Object.entries(updatedAttributes).every(
                ([key, val]) =>
                    variation.attributes.some((attr) => attr.slug === key && attr.option === val)
            )
        );

        setMatchedVariation({ ...matchedVariation, [selectedProductId]: matched || null });
    };

   
    return (
        <Modal title="Create New Order" open={isOpen} onCancel={() => onClose(false)} footer={null} width={"60%"}>
            <Spin spinning={productLoading}>

            <div style={{ height: "500px", overflowY: "auto", padding: 20 }}>
                <Steps current={currentStep} onChange={setCurrentStep}>
                    {steps.map((step, index) => (
                        <Step key={index} title={step.title} />
                    ))}
                </Steps>

                <Form form={form} layout="vertical" style={{ marginTop: "18px" }}>
                    {currentStep === 0 && (
                        <Form.List initialValue={[{ product_id: undefined, quantity: null, meta_data: [] }]} name="products">
                            {(fields, { add, remove }) => (
                                <div>
                                    {fields.map(({ key, name, ...restField }) => {
                                        const selectedProductId = form.getFieldValue(["products", name, "product_id"]);
                                        const selectedProduct = products.find(p => p.productId === selectedProductId);
                                        return (
                                            <Row style={{ marginBottom: 10 }} key={key} gutter={[16, 16]} align="middle" wrap>
                                                {/* Product Selection */}
                                                <Col xs={24} sm={24} md={24} lg={8}>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, "product_id"]}
                                                        label="Select Product"
                                                        rules={[{ required: true, message: "Please select a product" }]}
                                                    >
                                                        <Select
                                                            placeholder="Choose a product"
                                                            style={{ width: "100%" }}
                                                            onChange={(value) => {
                                                                fetchProductVariations(value);
                                                                form.setFieldsValue({ products: [...form.getFieldValue("products")] });
                                                            }}
                                                        >
                                                            {products.length && products.map(product => (
                                                                <Select.Option key={product.id} value={product.id}>
                                                                    {product.name}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>

                                                {/* Quantity */}
                                                <Col xs={24} sm={24} md={24} lg={6}>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, "quantity"]}
                                                        label="Quantity"
                                                        rules={[{ required: true, message: "Please enter quantity" }]}
                                                    >
                                                        <Input type="number" min={1} style={{ width: "100%" }} />
                                                    </Form.Item>
                                                </Col>

                                                <>
                                                    <>
                                                        {selectedProduct?.attributes?.map((attr, index) => {
                                                            if (attr.slug === "pa_cosmetic-condition") {
                                                                return <Col xs={24} sm={12} md={6} key={index}>
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name, "meta_data", index, "value"]}
                                                                        label={attr.name}
                                                                        rules={[{ required: true, message: `Please select ${attr.name}` }]}
                                                                    >
                                                                        <Select placeholder={`Select ${attr.name}`} style={{ width: "100%" }}>
                                                                            {attr.options.map(option => {

                                                                                return <Select.Option key={selectedProduct?.productId} value={option}>
                                                                                    {option}
                                                                                </Select.Option>
                                                                            })}
                                                                        </Select>
                                                                    </Form.Item>

                                                                    {/* Hidden Fields */}
                                                                    <Form.Item name={[name, "meta_data", index, "key"]} initialValue={attr.slug} hidden>
                                                                        <Input />
                                                                    </Form.Item>
                                                                    <Form.Item name={[name, "meta_data", index, "display_key"]} initialValue={attr.name} hidden>
                                                                        <Input />
                                                                    </Form.Item>
                                                                    <Form.Item name={[name, "meta_data", index, "display_value"]} dependencies={[name, "meta_data", index, "value"]} hidden>
                                                                        <Input />
                                                                    </Form.Item>
                                                                </Col>
                                                            }

                                                        })}
                                                    </>
                                                    {variations[selectedProductId] && (
                                                        <>

                                                            {Object.entries(
                                                                variations[selectedProductId]?.reduce((acc, variation) => {
                                                                    variation.attributes.forEach(({ name, slug, option }) => {
                                                                        if (!acc[slug]) acc[slug] = new Set();
                                                                        acc[slug].add(option);
                                                                    });
                                                                    return acc;
                                                                }, {})
                                                            ).map(([slug, options], index) => (

                                                                <Col xs={24} md={6} lg={8} >
                                                                    <div key={slug} >
                                                                        {/* <label>{slug.replace("pa_", "").toUpperCase()}:</label> */}
                                                                        <Form.Item
                                                                            {...restField}
                                                                            name={[name, "line_items", index, slug]}
                                                                            label={slug.replace("pa_", "")}
                                                                            rules={[{ required: true, message: `Please select ${options}` }]}
                                                                        >
                                                                            <Select

                                                                                style={{ width: "100%" }}
                                                                                placeholder={`Select ${slug}`}
                                                                                onChange={(value) => handleSelectAttribute(slug, value, selectedProductId)}
                                                                            // value={selectedAttributes[slug] || undefined}
                                                                            >
                                                                                {[...options].map((option) => (
                                                                                    <Select.Option key={option} value={option}>
                                                                                        {option}
                                                                                    </Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Form.Item>
                                                                    </div>

                                                                </Col>
                                                            ))}


                                                            {matchedVariation[selectedProductId] && (
                                                                <div style={{ marginTop: "10px", fontWeight: "bold" }}>
                                                                    Selected Variation: ${matchedVariation[selectedProductId].price}
                                                                    ({matchedVariation[selectedProductId].stock_status})
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                                {/* Remove Product Button */}
                                                <Col xs={24} sm={12} md={6} lg={4} >

                                                    <Button onClick={() => remove(name)} block >
                                                        Remove
                                                    </Button>
                                                </Col>

                                            </Row>
                                        );
                                    })}

                                    {/* Add Product Button */}
                                    <Row justify="center">
                                        <Col>
                                            <Button type="dashed" onClick={() => add()} block>
                                                Add Product
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Form.List>
                    )}

                    {currentStep === 1 && (
                        <Row gutter={[16, 16]}>
                            {[
                                { label: "First Name", key: "first_name" },
                                { label: "Last Name", key: "last_name" },
                                { label: "Address 1", key: "address_1" },
                                { label: "Address 2", key: "address_2" },
                                { label: "City", key: "city" },
                                { label: "Postcode", key: "postcode" },
                                { label: "Country", key: "country" },
                                { label: "Email", key: "email" },
                                { label: "Phone", key: "phone" }
                            ].map(({ label, key }) => (
                                <Col key={key} xs={24} sm={12}>
                                    <Form.Item
                                        label={label}
                                        name={["billing", key]}
                                        rules={[{ required: true, message: `Please enter ${label}` }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            ))}
                        </Row>
                    )}

                    {currentStep === 2 && (
                        <Row gutter={[16, 16]}>
                            {[
                                { label: "First Name", key: "first_name" },
                                { label: "Last Name", key: "last_name" },
                                { label: "Address 1", key: "address_1" },
                                { label: "Address 2", key: "address_2" },
                                { label: "City", key: "city" },
                                { label: "Postcode", key: "postcode" },
                                { label: "Country", key: "country" },
                                { label: "Email", key: "email" },
                                { label: "Phone", key: "phone" }
                            ].map(({ label, key }) => (
                                <Col key={key} xs={24} sm={12}>
                                    <Form.Item
                                        label={label}
                                        name={["shipping", key]}
                                        rules={[{ required: true, message: `Please enter ${label}` }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            ))}
                        </Row>
                    )}

                    {currentStep === 3 && (
                        <Form.Item
                            label="Payment Method"
                            name="paymentMethod"
                            rules={[{ required: true, message: "Please select a payment method" }]}
                        >
                            <Select style={{ width: "200px", display: "block", margin: "0 auto" }}>
                                {[
                                    { label: "Bank Wire Transfer", value: "bacs" },
                                    // { label: "PayPal", value: "paypal" },
                                    // { label: "Credit Card", value: "stripe" },
                                    // { label: "Cash on Delivery", value: "cod" }
                                ].map(method => (
                                    <Select.Option key={method.value} value={method.value}>
                                        {method.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    )}
                </Form>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
                <Button disabled={currentStep === 0} onClick={() => setCurrentStep((prev) => prev - 1)}>Previous</Button>
                {currentStep < steps.length - 1 ? (
                    <Button onClick={() => setCurrentStep((prev) => prev + 1)}>Next</Button>
                ) : (
                    <Button loading={loading} type="primary" style={{ background: "#1677ff", color: "white" }} onClick={handleSaveOrder}>Save Changes</Button>
                )}
            </div>
            </Spin>

        </Modal >
    );
};

export default AddNewOrderToWooCommerce;